import { Directive, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { Subject, interval } from 'rxjs';
import { takeUntil, debounce } from 'rxjs/operators';
import { AdsInfiniteScrollService } from '../service/ads-infinite-scroll.service';

@Directive({

  selector: '[Infinite-Scroll]'

})

export class AdsInfiniteScrollDirective {

  private observer: IntersectionObserver;

  private scrollStatusSubject = new Subject<boolean>();

  private onDestroy$ = new Subject();

  constructor(private element: ElementRef, private _InfiniteScrollService: AdsInfiniteScrollService) { }

  ngOnInit() {

    // 

    this.observer = new IntersectionObserver((entries) => {

      entries.forEach((entry) => {

        if (entry.isIntersecting) this.scrollStatusSubject.next(true);

      });

    });

    this.observer.observe(this.element.nativeElement);

    this.scrollStatusSubject.pipe(

      debounce(() => interval(500)), // Debounce for 500 millisecond

      takeUntil(this.onDestroy$) // Unsubscribe when the component is destroyed

    ).subscribe((status) => {

      this.onScrollToBottom();

    });

  }

  ngOnDestroy() {

    if (this.observer) {

      this.observer.disconnect();

    }

  }

  private onScrollToBottom() {

    this._InfiniteScrollService.updateScrollStatus(true)

  }

}
